import React from "react";
import PropTypes from "prop-types";

import { FormGroup, Button, Grid } from "@material-ui/core";

import { withStyles } from "@material-ui/core";

import PhotoComponentStyle from "./PhotoComponent";

import Camera from "./camera";

const PhotoComponent = props => {
  const {
    displayCamera,
    handleDisplayCamera,
    setFieldValue,
    values,
    classes
  } = props;

  return (
    <Grid container spacing={24} className={classes.photobox}>
      <Grid item xs={12}>
        <FormGroup>
          {displayCamera ? (
            <Camera
              handleDisplayCamera={handleDisplayCamera}
              open={displayCamera}
              setFieldValue={setFieldValue}
            />
          ) : (
            <div>
              <div>
                <img width="104" height="104" src={values.photo} alt="kid" />
              </div>
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  handleDisplayCamera();
                }}
              >
                Take a photo
              </Button>
            </div>
          )}
        </FormGroup>
      </Grid>
    </Grid>
  );
};

PhotoComponent.propTypes = {
  displayCamera: PropTypes.bool,
  handleDisplayCamera: PropTypes.func,
  setFieldValue: PropTypes.func,
  values: PropTypes.object,
  classes: PropTypes.object
};

export default withStyles(PhotoComponentStyle)(PhotoComponent);
